export default {
  state: {
    data: {},
    order: [],
    loading: false,
    error: null,
    queue: [],
    config: {
      default: 'PRODUCT_PERMISSION_GROUP',
      append: '_PERMISSION',
      path: 'product/group/permission/',
      error: { active: false },
      get: { active: false, msg: '' },
      update: { active: false, msg: 'Subprodukt-Seite aktualisiert.' },
      create: { active: false, msg: 'Subprodukt-Seite erstellt.' },
      delete: { active: false, msg: 'Subprodukt-Seite gelöscht.' },
      admin: {
        error: { active: true },
        get: { active: false, msg: '' },
        update: { active: true, msg: 'Subprodukt-Seite aktualisiert.' },
        create: { active: false, msg: 'Subprodukt-Seite erstellt.' },
        delete: { active: false, msg: 'Subprodukt-Seite gelöscht.' },
      },
    },
  },
  getters: {
    // dataByParentId: (state) => (id) => {
    //   const { routes } = state.data[id] || { routes: [] };
    //   return routes;
    // },
  },
  mutations: {},
  actions: {
    // Unnecessary since org/group/permission is needed for update only
    // SOCKET_PRODUCT_PERMISSION_GROUP_ROUTES({ commit, dispatch, getters }, payload) {
    //   if (process.env.NODE_ENV !== 'production') {
    //     console.log(`[${getters.config.path}] SOCKET_PRODUCT_PERMISSION_GROUPS`, payload);
    //   }
    //   dispatch('HANDLE_PAYLOAD', payload[1]);
    //   // for (let i = 0; i < payload[1].length; i += 1) {
    //   //   const element = payload[1][i];
    //   //   dispatch('product/GET', element.id);
    //   //   dispatch('sub/GET', element.id);
    //   //   dispatch('user/GET', element.id);
    //   // }
    //   commit('SET_LOADING', false);
    // },
  },
};
